import Axios from "axios";
import {AUTH_CREDENTIALS_NAME, APIURL} from "./../Constantes";

const getCabecera = () =>{
    let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
    let cabecera = { Authorization: `bearer ${Token}`,
    "Content-Type": "application/json",
    Accept: "application/json",}
    return cabecera;
}

const urlDuck = "Spot";

const dataInicial = {
  array: [],
  exito: 0,
  objeto: {},
};

const GET_HABITACIONES_ALL = "GET_HABITACIONES_ALL";
const GET_HABITACIONES_BY_PAQUETE = "GET_HABITACIONES_BY_PAQUETE";
const GET_HABITACIONES_CLEAR_STATE = "GET_HABITACIONES_CLEAR_STATE";
const DELETE_HABITACIONES_BY_PAQUETE = "DELETE_HABITACIONES_BY_PAQUETE";

export default function habitacionesReducer (state = dataInicial, action) {
  switch (action.type) {
    case DELETE_HABITACIONES_BY_PAQUETE:
      return { ...state, exito: action.payload.exito };
    case GET_HABITACIONES_ALL:
      return { ...state, array: action.payload.array };
    case GET_HABITACIONES_BY_PAQUETE:
      return { ...state, array: action.payload.array };
    case GET_HABITACIONES_CLEAR_STATE: 
      return {...state, array: action.payload.array, exito: action.payload.exito, objeto: action.payload.objeto}
    default:
      return state;
  }
}
export const eliminarHabitacionesPaqueteAction = (IdPaquete, IdTipoPaquete) => async (dispatch) => {
  try {
    const respuesta = await Axios.delete(`${APIURL}/${urlDuck}/Package/${IdPaquete}/${IdTipoPaquete}`,
    {
        headers: getCabecera()
    });
    dispatch({
        type: DELETE_HABITACIONES_BY_PAQUETE,
        payload: {
            exito: 1
        }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
};

export const obtenerHabitacionesByIdPaqueteAction = (IdPaquete) => async (dispatch) => {
  try {
    const respuesta = await Axios.get(`${APIURL}/${urlDuck}/Package/${IdPaquete}`,
    {
        headers: getCabecera()
    });
    dispatch({
        type: GET_HABITACIONES_BY_PAQUETE,
        payload: {
            array: respuesta.data
        }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
};

export const clearHabitacionesState = () => async (dispatch) =>{
    dispatch({
        type: GET_HABITACIONES_CLEAR_STATE,
        payload :{
          array: [],
          exito: 0,
          objeto: {}
        }
    })
}
